import { isoDate } from '../../utils/format';

export const DEFAULT_RANGE = 'ytd';

// The longest range the API takes, in days (MAX_RANGE_DAYS in social/rest/ads.py)
export const MAX_RANGE_DAYS = 3660;

export const RANGE_OPTIONS = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: 'this_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'ytd', label: 'Year to date' },
  { value: 'custom', label: 'Custom range' },
];

/**
 * Days from since to until (YYYY-MM-DD), both included
 */
export function rangeDays(since, until) {
  return (Date.parse(until) - Date.parse(since)) / 86400000 + 1;
}

/**
 * A query's range, or the default when it has none or one no longer offered (from an old link)
 */
export function knownRange(range) {
  return RANGE_OPTIONS.some((option) => option.value === range) ? range : DEFAULT_RANGE;
}

/**
 * { since, until } (YYYY-MM-DD) of a query's range: a preset, or since / until when custom
 */
export function resolveRange({ range, since, until }) {
  const today = new Date();
  const daysAgo = (days) => new Date(today.getFullYear(), today.getMonth(), today.getDate() - days);
  switch (knownRange(range)) {
    case 'custom':
      return { since: since || isoDate(daysAgo(29)), until: until || isoDate(today) };
    case 'this_month':
      return { since: isoDate(new Date(today.getFullYear(), today.getMonth(), 1)), until: isoDate(today) };
    case 'last_month':
      return {
        since: isoDate(new Date(today.getFullYear(), today.getMonth() - 1, 1)),
        until: isoDate(new Date(today.getFullYear(), today.getMonth(), 0)),
      };
    case 'ytd':
      return { since: isoDate(new Date(today.getFullYear(), 0, 1)), until: isoDate(today) };
    default: {
      const days = parseInt(knownRange(range), 10);
      return { since: isoDate(daysAgo(days - 1)), until: isoDate(today) };
    }
  }
}
